module.exports = __webpack_public_path__ + "static/media/img_logo.27786320.svg";